import { Card, Button, Space, message, Tag, Image, InputNumber } from "antd";
import { useEffect, useState } from "react";
import api from "../services/api";
import { useCart } from "../context/CartContext";

export default function ProductCard({ product, cartItems, onDetail }) {
  const subCategoryData = product.subcategory;

  const productImage = product.images?.[0]?.image_url;

  const [qty, setQty] = useState(1);
  const [inCart, setInCart] = useState(false);
  const { items, addItem } = useCart();

  useEffect(() => {
    const item = items.find((c) => c.productId === product.id);

    if (item) {
      setInCart(true);
      setQty(item.qty);
    }
  }, [items, product.id]);

  const productBasePrice = product.base_price;
  const productDiscountPrice = product.discount_price;

  const basePrice =
    productBasePrice && Number(productBasePrice) > 0
      ? Number(productBasePrice)
      : Number(subCategoryData?.base_price || 0);

  const discountPrice =
    productDiscountPrice && Number(productDiscountPrice) > 0
      ? Number(productDiscountPrice)
      : Number(subCategoryData?.discount_price || 0);

  const handleAddToCart = async (e) => {
    e.stopPropagation(); // 🔥 IMPORTANT (fix drawer issue)

    try {
      const existing = items.find((i) => i.productId === product.id);

      if (existing) {
        // 🔄 UPDATE
        await api.put(`/cart/${existing.cartId}`, {
          quantity: qty,
        });

        message.success("Cart updated");
      } else {
        // ➕ ADD
        const res = await api.post("/cart", {
          product_id: product.id,
          quantity: qty,
        });

        addItem(
          product,
          {
            id: product.id,
            price: discountPrice || basePrice,
          },
          qty,
          res.data.id,
        );

        message.success("Added to cart");
      }

      setInCart(true);
    } catch (err) {
      console.error(err); // 🔥 ADD THIS (debug)
      message.error("Cart failed");
    }
  };

  return (
    <Card
      hoverable
      cover={
        <img
          alt={product.name}
          src={`${process.env.REACT_APP_API_URL}${productImage}`}
          onClick={() => onDetail(product)}
          style={{
            height: "auto",
            objectFit: "cover",
            width: "100%",
          }}
        />
      }
    >
      <h4
        className="product-title"
        title={product.name} // 🔥 hover full text
        onClick={() => onDetail(product)}
      >
        {product.name}
      </h4>

      {discountPrice > 0 ? (
        <>
          <span
            style={{
              textDecoration: "line-through",
              color: "#999",
              marginRight: 5,
            }}
          >
            £{basePrice}
          </span>

          <Tag color="green">£{discountPrice}</Tag>
        </>
      ) : (
        <p>£{basePrice}</p>
      )}

      {/* ATTRIBUTES */}

      {/* <div style={{ marginBottom:10 }}>
        {product.attributes?.map(attr => (
          <Tag key={attr.id} color="blue">
            {attr.Attribute?.name}: {attr.AttributeValue?.value}
          </Tag>
        ))}
      </div> */}

      {/* QUANTITY */}
      <div style={{ display: "flex", gap: 8, marginTop: 5 }}>
        <InputNumber
          min={1}
          value={qty}
          size="small"
          onChange={setQty}
          style={{ width: "40%" }} // 🔥 40%
        />

        <Button
          type="primary"
          size="small"
          style={{
            width: "60%", // 🔥 60%
            background: inCart ? "#52c41a" : undefined,
          }}
          onClick={handleAddToCart}
        >
          {inCart ? "Update Cart" : "Add To Cart"}
        </Button>
      </div>
    </Card>
  );
}
